var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusMessage)?_c('p',{staticClass:"terrain-autosave__status",class:`terrain-autosave__status--${_vm.status}`,attrs:{"role":_vm.isFailure ? 'alert' : 'status',"aria-live":"polite"}},[_vm._v(" "+_vm._s(_vm.statusMessage)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }